import React, { useState, useContext } from "react";
import styled from "styled-components";
import Button from "../Button/Button";
import ButtonHref from "../Button/ButtonHref";
import LoginForm from "../LoginForm/LoginForm";
import { device } from "../../services/styles";
import IcomoonReact from "icomoon-react";
import iconSet from "../../fonts/selection.json";
import { UserContext } from "../../context/UserContext";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  margin: 40px 0;
  padding: 20px;
  background: transparent
    linear-gradient(
      180deg,
      rgba(109, 144, 239, 1) 0%,
      rgba(74, 112, 216, 1) 100%
    )
    0% 0% no-repeat padding-box;
  border-radius: 8px;
  text-align: center;
  @media ${device.tabletLarge} {
    flex-direction: row;
    justify-content: center;
  }
`;

const Header = styled.p`
  color: #fff;
  font-size: 18px;
  line-height: 24px;
  margin-bottom: 20px;
  font-weight: 900;
  margin: 0;
  width: 100%;
  text-align: center;
  @media ${device.tabletLarge} {
    font-size: 24px;
    line-height: 26px;
  }
`;
const Box = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  &:nth-of-type(2) {
    margin-top: 40px;
    @media ${device.tabletLarge} {
      margin-top: 20px;
    }
  }
  @media ${device.tabletLarge} {
    margin: 20px 5% 0 5%;
  }
`;

const ButtonTitle = styled.span`
  font-size: 18px;
  line-height: 20px;
  color: #fff;
`;

const LoginContainer = styled.div`
  position: relative;
  padding: 20px;
  background: transparent
    linear-gradient(
      180deg,
      rgba(109, 144, 239, 1) 0%,
      rgba(74, 112, 216, 1) 100%
    )
    0% 0% no-repeat padding-box;
  border-radius: 8px;
`;

const IconContainer = styled.div`
  position: absolute;
  top: 15px;
  right: 15px;
  cursor: pointer;
  display: block;
`;

const SubscriptionBox = () => {
  const [showLoginForm, setShowLoginForm] = useState(false);
  const [user] = useContext(UserContext);
  return (
    <>
      <Container>
        <Header>Ten i inne artykuły przeczytasz dzięki subskrypcji</Header>
        {!user.authorized && (
          <Box>
            <ButtonTitle>Jeśli posiadasz subskrypcję</ButtonTitle>
            <Button
              color={"green"}
              type={"gradient"}
              customStyle={{ marginTop: 10 }}
              onClickFunction={() => setShowLoginForm(true)}
            >
              Zaloguj się
            </Button>
          </Box>
        )}
        {/* TODO  */}
        <Box>
          <ButtonTitle>Czytaj bez ograniczeń</ButtonTitle>
          <ButtonHref color={"white"} customStyle={{ marginTop: 10 }}>
            Subskrybuj
          </ButtonHref>
        </Box>
      </Container>
      {showLoginForm && (
        <LoginContainer>
          <IconContainer onClick={() => setShowLoginForm(false)}>
            <IcomoonReact
              iconSet={iconSet}
              color="#fff"
              size={16}
              icon="close"
              onClick={() => setShowLoginForm(false)}
            />
          </IconContainer>
          <LoginForm />
        </LoginContainer>
      )}
    </>
  );
};

export default SubscriptionBox;
